module.exports = __webpack_public_path__ + "media/YRL6BSM-siren.afe90945.mp3";